import Image from "next/image";
import React from "react";
import { MdArrowOutward } from "react-icons/md";
import { sub_section_heading } from "./new-ui/constants";

const WebinarData = [
    {
        imgSrc: "https://assets.gallabox.com/gb-home/webinar/webinar-9.png",
        label: "WEBINAR",
        title: "Why 60% of real estate leads never close and how to fix it in 30 days?",
        link: "/webinars/why-60-percent-real-estate-leads-never-close",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/webinar/webinar-8.png",
        label: "WEBINAR",
        title: "How India's Top Real Estate Brands Use WhatsApp Differently",
        link: "/webinars/whatsapp-real-estate",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/webinar/webinar-7.png",
        label: "WEBINAR",
        title: "Launch Your WhatsApp Chatbot in Just 5 Minutes",
        link: "/webinars/building-whatsapp-chatbot",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/webinar/webinar-6.png",
        label: "WEBINAR",
        title: "How Travel Brands Scale with WhatsApp Automation",
        link: "/webinars/whatsapp-automation-for-travel-companies",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/webinar/webinar-5.png",
        label: "WEBINAR",
        title: "WhatsApp Marketing 2025: Campaigns That Convert",
        link: "/webinars/whatsapp-playbook",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/webinar/webinar-4.png",
        label: "WEBINAR",
        title: "WhatsApp for Healthcare: Your New Digital Receptionist",
        link: "/webinars/whatsapp-healthcare",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/webinar/webinar-3.png",
        label: "WEBINAR",
        title: "From Clicks to Conversions: WhatsApp Drip Marketing 101",
        link: "/webinars/automate-sales-drip-marketing",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/webinar/webinar-2.png",
        label: "WEBINAR",
        title: "3 WhatsApp Funnels That Drove 77% More Leads (Steal These!)",
        link: "/webinars/whatsapp-funnels",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/webinar/webinar-1.png",
        label: "WEBINAR",
        title: "Why You're Losing Sales (And How WhatsApp Can Fix It)",
        link: "/webinars/losing-sales-whatsapp",
    },
];

const WebinarCard: React.FC = () => {
    return (
        <section className="max-w-7xl mx-auto py-12">
            <h2 className={`${sub_section_heading} mb-5 pl-5`} style={{ fontFamily: "Degular Display" }}>
                Catch our on-demand webinars
            </h2>
            <div className="grid md:grid-cols-3 grid-cols-1 px-5 gap-6">
                {WebinarData.map((book, index) => (
                    <div key={index} className="bg-white md:shadow-md hover:shadow-2xl flex flex-col h-[500px] max-w-sm" onClick={() => window.open(book.link, "_blank")}>
                        <Image width={399} height={210} style={{ height: "200px", width: "100%" }} src={book.imgSrc} alt={book.title} className="md:object-cover object-contain" />
                        <div className="flex flex-col justify-between flex-1 p-6 border border-gray-200">
                            <div>
                                <p className="text-gray-600 text-sm font-medium mb-2">{book.label}</p>
                                <p className="text-xl font-semibold text-black">{book.title}</p>
                            </div>
                            <button className="mt-6 px-5 py-2 rounded bg-black text-white text-base font-medium flex items-center gap-2 w-fit">
                                Watch Now <MdArrowOutward />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default WebinarCard;
